import { useSessionStorage as baseUseSessionStorage } from '@vueuse/core';

import { browserStorageNamespacedKey } from '@/utils/browserStorage';

export function useSessionStorage(key, initialValue = null, options = {}) {
  const dhKey = browserStorageNamespacedKey(key);
  return baseUseSessionStorage(dhKey, initialValue, options);
}
